import type { CSSObject } from '@emotion/react'

export const enum Elevation {
  /**
   * No elevation--on the surface.
   */
  E0,
  /**
   * Objects like moment cards and content cards.
   */
  E1,
  /**
   * Secondary or default-hidden controls, like sidebars, menus, and popovers.
   */
  E2,
  /**
   * Temporary UI that takes over a significant portion of the viewport and
   * changes where the user’s attention is focused, like drawers.
   */
  E3,
}

export type ShadowStyle = Record<Elevation, Pick<CSSObject, 'boxShadow'>>
